<template>
  <div>
    <div class="d-flex align-items-center mb-1">
      <h3 class="mb-0 font-weight-light fz-base" aria-hidden="true">{{ title }}</h3>
      <slot v-if="!disabled" name="icon" />
    </div>
    <div :class="['d-flex flex-column', { 'border br-8 p-3': $hasSlotContent($slots.text) || disabled }]">
      <slot name="beforeText" />
      <slot name="text">
        <!-- FYI: Textarea defaults to 2 rows if no row attribute is given.
        With the combination of max-rows the height will be automatically calculated -->
        <STextarea
          v-model="proxyValue"
          data-cy="comment-box"
          :max-height="1026"
          :placeholder="placeholder"
          :label-text="title"
          hide-label
          no-resize
          :rows="!disabled ? 3 : 2"
          :disabled="disabled"
        />
      </slot>
      <slot name="afterText" />
    </div>
  </div>
</template>

<script>
export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiCommentBox',
  props: {
    modelValue: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
      required: true,
    },

    placeholder: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    proxyValue: {
      get() {
        return this.modelValue
      },

      set(newValue) {
        this.$emit('update:modelValue', newValue)
      },
    },
  },

  emits: ['update:modelValue'],
}
</script>

<style scoped lang="scss">
.no-border {
  border: 0 !important;
}

:deep(.form-control:disabled) {
  color: $color-gray-400;
}
</style>
